const TOGGLE_SDS_COPY_MODAL = 'app/modal/TOGGLE_SDS_COPY_MODAL';

export default {
  TOGGLE_SDS_COPY_MODAL
};
